<template>
  <div class="json-editor border border-green-900 p-1">
    <div
      class="object-view"
      :class="{
        'object-view_list': parsedItem.type === 'object' || parsedItem.type === 'array',
        'object-view--collapsed': parsedItem.collapsed,
      }"
    >
    <!-- {{parsedItem}} -->
      <div class="object-view__key">
        <button
          v-if="parsedItem.type === 'object' || parsedItem.type === 'array'"
          type="button"
          class="json-editor__btn json-editor__btn_icon"
          aria-controls="trigger"
          :aria-expanded="!parsedItem.collapsed ? 'true' : 'false'"
          @click="parsedItem.collapsed = !parsedItem.collapsed"
        >
          <b>
            <slot name="icon-collapse">
              <span
                class="btn-icon btn-icon_collapse"
                :title="parsedItem.collapsed ? 'Expand' : 'Collapse'"
                >^</span
              >
            </slot>
            <i v-if="parsedItem.type === 'object'">{{ `{ ${parsedItem.value.length} }` }}</i>
            <i v-if="parsedItem.type === 'array'">{{ `[ ${parsedItem.value.length} ]` }}</i>
          </b>
        </button>
        <span class="json-editor__input key__input"
          ><i>{{ parsedItem.key }}</i></span
        >
      </div>
      <div v-show="!parsedItem.collapsed" class="object-view__value">
        <item-view
          v-if="parsedItem.type === 'object' || parsedItem.type === 'array'"
          v-model="parsedItem.value"
          :item-type="parsedItem.type"
           :item-key="parsedItem.serialKey"
          :parsed-item="parsedItem"
          :parsed-data="parsedItem.value"
          :showCopyIcon="showCopyIcon"
        >
          <template >
            <slot name="icon-add"> </slot>
          </template>
          <template #icon-delete>
            <slot name="icon-delete"> </slot>
          </template>
          <template #icon-drag>
            <slot name="icon-drag"> </slot>
          </template>
          <template #icon-collapse>
            <slot name="icon-collapse"> </slot>
          </template>
        </item-view>
        <template v-else>
          <span v-if="parsedItem.type === 'null'" class="json-editor__input value__input">null</span>
          <input
            v-if="parsedItem.type === 'string'"
            v-model.trim="parsedItem.value"
            type="text"
            class="json-editor__input value__input"
          />
          <input
            v-if="parsedItem.type === 'number'"
            v-model.number="parsedItem.value"
            type="number"
            class="json-editor__input value__input"
            step="0.1e-100"
          />
          <select
            v-if="parsedItem.type === 'boolean'"
            v-model="parsedItem.value"
            class="json-editor__select value__input"
          >
            <option :value="true">true</option>
            <option :value="false">false</option>
          </select>
        </template>
      </div>
      <div class="object-view__tools">
        <select v-model="parsedItem.type" class="json-editor__select" @change="parsedItem.changeType()">
          <option v-for="(type, i) in typesList" :key="i" :value="type">
            {{ type }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import Item from '../helpers/item';
import ItemView from './item-view.vue';

const typesList = ['object', 'array', 'string', 'number', 'boolean', 'null'];

export default {
  name: 'JsonEditor',
  components: {
    ItemView,
  },
  provide() {
    return {
      typesList,
      options: this.options,
    };
  },
  props: {
    dataInput: {
      type: [String, Number, Boolean, Array, Object],
      default() {
        return null;
      },
    },
    showCopyIcon: {
      type: Boolean,
      required: false,
      "default": false,
    },
    options: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      item: new Item({ key: 'root', value: this.dataInput }, 'object', '0'),
      cache: {
        value: null,
        type: 'null',
      },
      typesList,
    };
  },
  computed: {
    parsedItem: function () {
      this.$emit('data-output', this.item.buildItem());
      return this.item;
    }
  },
  watch: {
    deep: true,
    immediate: true,
    item: {
      // deep: true,
      immediate: true,
      handler() {
        const newValue = JSON.stringify(this.item.value);

        if (newValue === JSON.stringify(this.cache.value) && this.item.type === this.cache.type)
          return;

        this.cache.type = `${this.item.type}`;
        this.cache.value = JSON.parse(newValue);

        this.$emit('data-output', this.item.buildItem());
      }
    },
    dataInput (val, oldVal) {
      console.log('update dataInput-', val, oldVal)
      this.item = new Item({ key: 'root', value: this.dataInput }, 'object', '0');
    }
  },
  mounted() {
    this.$emit('data-output', this.item.buildItem());
  },
};
</script>
